type WithDomain = { domain: string };

export const movePrimaryItemToStart = <T extends WithDomain>(primaryDomain: string, data: T[]): T[] => {
    const primaryEntry = data.find((item) => item.domain === primaryDomain);

    if (!primaryEntry) {
        return data;
    }

    return [primaryEntry, ...data.filter((item) => item.domain !== primaryDomain)];
};
